const BROWSER_FEATURES = _getBrowserFeatures();

export function getBrowserFeatures() {
  return {
    ...BROWSER_FEATURES,
  };
}

export function isWebRtcSupported() {
  return BROWSER_FEATURES.webRtc;
}

export function isWebAudioSupported() {
  if (window.webkitAudioContext && !window.AudioContext) {
    const matches = navigator.userAgent.match(/AppleWebKit\/\d+\..* Version\/(\d+)\./);
    if (matches && matches[1] && matches[1] === '11') {
      return false;
    }
  }

  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (AudioContext.prototype.createMediaStreamDestination) {
    return true;
  }

  return false;
}

function _getBrowserFeatures() {
  const ret = {};

  ret.https = window.location.protocol === 'https:';

  ret.AudioContext = !!(window.AudioContext || window.webkitAudioContext);
  ret.RTCPeerConnection = isRTCPeerConnectionSupported();
  ret.RTCPeerConnection_addTrack = !!(ret.RTCPeerConnection && window.RTCPeerConnection.prototype.addTrack);
  ret.RTCPeerConnection_addTransceiver = !!(ret.RTCPeerConnection_addTrack && isAddTransceiverSupported());
  ret.MediaStream = !!window.MediaStream;
  ret.MediaStream_getTrackById = ret.MediaStream && 'getTrackById' in window.MediaStream.prototype;
  ret.MediaStream_active = ret.MediaStream && 'active' in window.MediaStream.prototype; // Firefox >= 52
  ret.getUserMedia = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

  ret.webRtc = !!(
    ret.AudioContext &&
    ret.RTCPeerConnection &&
    ret.RTCPeerConnection_addTrack &&
    ret.MediaStream &&
    ret.MediaStream_getTrackById &&
    ret.MediaStream_active &&
    ret.getUserMedia &&
    ret.https
  );

  ret.webAudio = ret.webRtc && isWebAudioSupported();

  return ret;
}

function isRTCPeerConnectionSupported() {
  if (typeof window.RTCPeerConnection !== 'function' || !window.RTCPeerConnection.prototype) {
    return false;
  }

  try {
    const pc = new RTCPeerConnection();
    pc.close();
    return true;
  } catch (e) {
  }

  return false;
}

// browser  versions   hasTransceivers
// chrome   67-68      no addTransceiver
// chrome   69-72      has addTransceiver, requires sdpSemantics: 'unified-plan'
// chrome   73-        yes
// firefox  52-58      no addTransceiver
// firefox  59-        yes
// safari   11-        yes

function isAddTransceiverReal() {
  const tempPc = new RTCPeerConnection();
  let canAddTransceiver = false;
  try {
    tempPc.addTransceiver('audio');
    canAddTransceiver = true;
  } catch (e) {
  }
  tempPc.close();
  return canAddTransceiver;
}

function isAddTransceiverSupported() {
  return !!(
    window.RTCRtpSender &&
    window.RTCPeerConnection &&
    window.RTCPeerConnection.prototype &&
    window.RTCPeerConnection.prototype.addTransceiver &&
    isAddTransceiverReal()
  );
}
